import UserPayments from './UserPayments';

export default UserPayments;
